/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notes_Reply_Aria_LabelInputs */

const en_notes_reply_aria_label = /** @type {(inputs: Notes_Reply_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event reply`)
};

const fr_notes_reply_aria_label = /** @type {(inputs: Notes_Reply_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reponse d'evenement`)
};

const de_notes_reply_aria_label = /** @type {(inputs: Notes_Reply_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignisantwort`)
};

const it_notes_reply_aria_label = /** @type {(inputs: Notes_Reply_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risposta all'evento`)
};

const ru_notes_reply_aria_label = /** @type {(inputs: Notes_Reply_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ответ на событие`)
};

const es_notes_reply_aria_label = /** @type {(inputs: Notes_Reply_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respuesta al evento`)
};

const zh_cn2_notes_reply_aria_label = /** @type {(inputs: Notes_Reply_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事件回复`)
};

const ja_notes_reply_aria_label = /** @type {(inputs: Notes_Reply_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント返信`)
};

const hi_notes_reply_aria_label = /** @type {(inputs: Notes_Reply_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`घटना प्रतिक्रिया`)
};

const pt_pt2_notes_reply_aria_label = /** @type {(inputs: Notes_Reply_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resposta ao evento`)
};

/**
* | output |
* | --- |
* | "Event reply" |
*
* @param {Notes_Reply_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const notes_reply_aria_label = /** @type {((inputs?: Notes_Reply_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notes_Reply_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_notes_reply_aria_label(inputs)
	if (locale === "de") return de_notes_reply_aria_label(inputs)
	if (locale === "it") return it_notes_reply_aria_label(inputs)
	if (locale === "ru") return ru_notes_reply_aria_label(inputs)
	if (locale === "es") return es_notes_reply_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_notes_reply_aria_label(inputs)
	if (locale === "ja") return ja_notes_reply_aria_label(inputs)
	if (locale === "hi") return hi_notes_reply_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_notes_reply_aria_label(inputs)
	return en_notes_reply_aria_label(inputs)
});